import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { toast } from '../hooks/use-toast';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const GoogleAuthSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { updateUser } = useAuth();

  useEffect(() => {
    handleSuccess();
  }, []);

  const handleSuccess = async () => {
    try {
      const token = searchParams.get('token');
      
      if (!token) {
        throw new Error('Token manquant');
      }

      // SEC-06 — auth via cookie HttpOnly : ne pas stocker le JWT en localStorage (vecteur XSS)
      axios.defaults.headers.common['Authorization'] = 'Bearer cookie-auth';

      // Get user info
      const response = await axios.get(`${API}/auth/me`, {});

      const user = response.data;
      
      // Store user and update context
      localStorage.setItem('baobab_user', JSON.stringify(user));
      updateUser(user);

      toast({
        title: "✅ Connexion réussie",
        description: `Bienvenue ${user.firstName} !`
      });

      // Redirect to dashboard
      setTimeout(() => {
        window.location.href = '/dashboard';
      }, 500);

    } catch (err) {
      console.error('Google auth success error:', err);
      
      toast({
        title: "Erreur",
        description: "Impossible de finaliser la connexion",
        variant: "destructive"
      });

      setTimeout(() => navigate('/login'), 2000);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-teal-50 flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-12 h-12 mx-auto text-[#1db584] animate-spin mb-4" />
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          Connexion en cours...
        </h2>
        <p className="text-gray-600">
          Finalisation de votre authentification Google
        </p>
      </div>
    </div>
  );
};

export default GoogleAuthSuccess;
